// extracted by mini-css-extract-plugin
export default {"middlePaneGrid":"IssueIndexPage-module__middlePaneGrid--rg2zq","feedbackLinkContainer":"IssueIndexPage-module__feedbackLinkContainer--Wd3oy"};